<template>
  <div class="page-container">
    <QrDetail variant="modal" />
    <div>
      <el-row class="item-wrap">
        <el-col :span="12">
          <div class="gallery-box">
            <el-carousel style="width: 500px;height: 500px;">
              <el-carousel-item :interval="5000" arrow="always" v-for="item in swiperSlidesPro" :key="item.photo" style="width: 500px;height: 500px;">
                <img :src="item.photo" class="itemImg" style="width: 500px;height: 500px;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="item-info">
            <div class="item-hd">
              <div class="detail-top">
                <h4><span class="title"> {{info.product_name}}</span>
                  <span class="countdown"><span>{{time | formatTimer}}</span></span>
                </h4>
                <div class="detail-bottom">
                  <el-row class="">
                    <el-col :span="6">
                      <span class="icon-font">邮</span><span>包邮</span>
                    </el-col>
                    <el-col :span="6">
                      <span class="icon-font">起</span>￥<span>{{startPrice | numberFormat(2)}}</span>
                    </el-col>
                    <el-col :span="6">
                      <span class="icon-font">加</span>￥<span>{{stepPrice | numberFormat(2)}}</span>
                    </el-col>
                    <el-col :span="6">
                      <span class="icon-font">看</span><span>{{info.look_count}}</span>
                    </el-col>
                  </el-row>
                </div>
                <div style="display: none;">
                  <div class="panel-hd">
                    <span>出价历史</span>
                  </div>
                  <div class="panel-bd">
                    <div class="price_wrap" v-if="bidding.length>0">
                      <div :class="['history-price',{lead:index==0},{beout:index!=0}]" v-for="(item,index) in bidding" :key="index">
                        <img :src="item.photo">
                        <div class="des">
                          <div class="name">{{item.nickname}}</div>
                          <div class="time">{{item.update_time}}</div>
                        </div>
                        <div class="cmmfont price"><span class="sign">￥</span>{{item.price}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="tips">
                  <el-alert :closable="false" title="温馨提示:需要缴纳保证金才能出价,为了不影响您的正常出价,请提前缴纳保证金,谢谢合作!" type="info">
                  </el-alert>
                </div> -->
              </div>
            </div>
            <div class="item-ft"  style="display: none;">
              <div class="info-l"><span>最高出价：</span><span class="price">￥<span>{{maxPrice | numberFormat(2)}}</span></span></div>
              <el-button type="primary" :disabled="btnState?false:true" @click="beforeAddprice">{{btnStatus}}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="page-bd">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h4 class="h4">作品介绍</h4>
        </div>
        <div class="desc_box">
          <dl>
            <dt>参数</dt>
            <dd>{{detail.suffix1}} / {{detail.standard}} /{{detail.quality}} /{{detail.create_year}}</dd>
          </dl>
          <dl>
            <dt>作者</dt>
            <dd>{{artist.artist_name}}</dd>
          </dl>
          <dl>
            <dt>创作时间</dt>
            <dd>{{detail.create_year}}</dd>
          </dl>
          <div class="content-box">
            <dl>
              <dt>描述</dt>
              <dd v-html="remark"></dd>
            </dl>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h4 class="h4">作者简介</h4>
        </div>
        <div class="p-content-main">
          <div class="a-content-main">
            <div class="headimgbox">
              <router-link :to="{path:'/artist/page',query:{id:artist.artist_id}}"><img v-bind:src="artist.artist_photo ?artist.artist_photo:artistDefault" alt="头像"></router-link>
            </div>
            <div class="artinfo">
              <div class="name">
                <router-link :to="{path:'/artist/page',query:{id:artist.artist_id}}">{{artist.artist_name}}</router-link>
              </div>
              <div class="des">
                <div class="des-l">
                  <span>作品<span>{{artist.product_count || 0}}</span></span><span>粉丝<span>{{artist.look_count || 0}}</span></span>
                </div>
                <el-button type="primary" @click="handleAddArtlike(artist.artist_id)" :icon="likeArt?'':'el-icon-plus'" plain>{{likeArtTxt}}</el-button>
              </div>
              <div class="a-content-wrap">
                <div class="content-s" v-html="synopsis"></div>
                <div>
                  <a href="" class="more" style="display: none;">查看全部》</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </el-card>
    </div>
    <el-dialog title="出价" class="addprice-dialog" :visible.sync="keyboard">
      <div class="price_content">
        <div class="intro clearfix">
          <img class="avatar" :src="swiperSlides[0] ||''">
          <div class="text">
            <div class="title">{{info.product_name}}</div>
            <div>当前价格<span class="price"><span class="sign">￥</span><span class="gotham">{{maxPrice | numberFormat(2)}}</span></span></div>
          </div>
        </div>
        <div class="operation-con">
          <div class="operation clearfix">
            <div @click="subtract()"><img class="btn" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjhGQzMxQ0M4N0VGMTFFN0I5QUVBRDM4NzI1Mzk5MTAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzYyQzg3QTI4N0VGMTFFN0I5QUVBRDM4NzI1Mzk5MTAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2OEZDMzFDQTg3RUYxMUU3QjlBRUFEMzg3MjUzOTkxMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2OEZDMzFDQjg3RUYxMUU3QjlBRUFEMzg3MjUzOTkxMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnpFkDAAAAECSURBVHja7Nw/SgNBFAfgN+62bjZKgh5AchFTSiDXsQ85jRDSegD7FOIFJPgnMekXMoJgii0lQvL94DFTzcDHe1NOel1+xMvz4iYiprluc1UhUWaUQUrpqde/rqtOHUVRnDxKNokyr5Ne/6ruXlxqk72cfY9P1emSaIGpjE87jIABAwYMGDBgwIABA0bAgAEDBgwYMGDAgAEjYMCAAQPmP1Me4pKH2fxPzxuP7nSMUQLjjTnom6BjwIABAwYMGDACBgwYMGDAgAEDBgwYAQMGDBgwYMCAAXOMMNumaUi0wDxuN2sSLTD372/Lr/XqM3TOb9LP512DvJ/kGuY6xxKxE2AAEs0qc3KmDL0AAAAASUVORK5CYII="></div>
            <div class="num gotham"><input value="0" readonly="" v-model="price" style=""></div>
            <div @click="add()"><img class="btn" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzYyQzg3QTU4N0VGMTFFN0I5QUVBRDM4NzI1Mzk5MTAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzYyQzg3QTY4N0VGMTFFN0I5QUVBRDM4NzI1Mzk5MTAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3NjJDODdBMzg3RUYxMUU3QjlBRUFEMzg3MjUzOTkxMCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3NjJDODdBNDg3RUYxMUU3QjlBRUFEMzg3MjUzOTkxMCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PtNb0+sAAAElSURBVHja7NwxSgNBFAbgSTalkBgVjxBSpM8J7ETwNKK9xxHETgN7CAsJOYBoRDbRdllntBAXxSIiG/L9MMwObLF8vBneNtPK87wKkrKMYxLHyWA4mrUSTHzYeJWyLMNyUYT5431RVdW4rVA+kmVZ2O7vhN29/V5cnoOppdvrp+kAzDeVE7MF5oeAAQMGDBgwYMCAAQMGjIABAwYMGDBg1jCdJnzExeXVl/Xx0aGKsZXAgAEDRsA0oo+p9ymrvv8ffY6KAQNmfc6Y384E/0q2EhgwYAQMmKb2Mav2OSoGDBgwYMCAETBgwIABAwYMGDBgwAgYMGD+MOmCnZhXMLUsiuc0XXdQfFZKuorpaf5QxOXZO8z07pZMCC9x3MRxOhiOpm8CDAD0kT2uoYAlwAAAAABJRU5ErkJggg=="></div>
          </div>
        </div>
        <div class="button-con">
          <button class="button red" id="give_money" :class="{'weui-btn_disabled':!addpriceState}" @click="addprice()"><i v-if="!addpriceState" class="weui-loading"></i> {{addpriceStateTxt}}</button>
        </div>
        <div class="buttons clearfix" @click.stop="_handleKeyPress">
          <div class="buttonNum gotham" data-num="1">1</div>
          <div class="buttonNum gotham" data-num="2">2</div>
          <div class="buttonNum gotham" data-num="3">3</div>
          <div class="buttonNum gotham" data-num="4">4</div>
          <div class="buttonNum gotham" data-num="5">5</div>
          <div class="buttonNum gotham" data-num="6">6</div>
          <div class="buttonNum gotham" data-num="7">7</div>
          <div class="buttonNum gotham" data-num="8">8</div>
          <div class="buttonNum gotham" data-num="9">9</div>
          <div class="buttonNum gotham" data-num="00">00</div>
          <div class="buttonNum gotham" data-num="0">0</div>
          <div class="clear" data-num="D"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss">
.addprice-dialog .el-dialog {
  width: 380px;
}
</style>
<style lang="scss" scoped>
.item-wrap {
  margin-top: 20px;
}
.gallery-box {
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.detail-top {
  padding: 15px 25px 15px 25px;
  border-bottom: dashed 2px #898989;
  h4 {
    line-height: 35px;
    vertical-align: middle;
    margin-bottom: 0;
    margin-top: 0;
    font-size: 0;
    .title {
      font-size: 20px;
      display: inline-block;
      width: 60%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .countdown {
      font-size: 14px;
      display: block;
      width: 40%;
      color: #e1251b;
      font-weight: bold;
      float: right;
      text-align: right;
    }
  }
}
.item-info {
  margin-left: 10px;
  border-radius: 8px;
  box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
}
.item-detail .detail {
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
}

.detail-top p {
  font-size: 14px;
  line-height: 32px;
  color: #666666;
}

.price {
  font-size: 22px;
  font-weight: normal;
  color: #bc230c;
}

.detail-top .item-code {
  text-align: center;
  padding: 18px 0;
}

.detail-top .item-code p {
  color: #cfa972;
  font-size: 12px;
  line-height: 12px;
  margin-top: 30px;
}

.detail-top .t-content {
  font-size: 12px;
  line-height: 24px;
  color: #666666;
}
.detail-bottom {
  padding-bottom: 15px;
  border-bottom: 1px solid #eeeeee;
}
.detail-bottom ul li {
  padding-right: 0px;
  padding-left: 0px;
}

.detail-bottom ul {
  list-style: none;
  color: #999999;
  font-size: 12px;
}

.detail-bottom .icon-font {
  display: inline-block;
  width: 25px;
  height: 24px;
  border-radius: 2px;
  border: solid 1px #cfa972;
  font-size: 12px;
  line-height: 24px;
  color: #cfa972;
  text-align: center;
  margin-right: 10px;
}
.item-ft {
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  .info-l {
    line-height: 40px;
  }
}
.panel-hd {
  height: 40px;
  font-size: 17px;
  line-height: 40px;
  font-weight: bold;
}
.panel-bd {
  margin-bottom: 10px;
}
.price_wrap {
  height: 270px;
  overflow-y: scroll;
  margin-left: -10px;
  margin-right: -10px;
}

.history-price {
  padding-left: 10px;
  padding-right: 13px;
  border-bottom: 1px solid #eeeeee;
  box-sizing: border-box;
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
}
.history-price img {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  overflow: hidden;
  vertical-align: middle;
  margin-right: 10px;
}
.history-price .des {
  border-bottom: none;
  height: auto;
  padding-top: 0;
  vertical-align: middle;
  display: inline-block;
}
.history-price .des .name {
  font-size: 14px;
  color: #333;
  line-height: 14px;
}
.history-price .des .time {
  margin-top: 5px;
  color: #999;
  font-size: 12px;
  line-height: 15px;
}
.history-price.lead .price {
  padding-right: 45px;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-position: right center;
  background-size: 33px auto;
}
.history-price.beout .price {
  padding-right: 45px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAiCAYAAADroA+yAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjg5QzY1NjQ3RjM4QjExRThCOUVCQzk0NTU2OUE5Nzg5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjg5QzY1NjQ4RjM4QjExRThCOUVCQzk0NTU2OUE5Nzg5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODlDNjU2NDVGMzhCMTFFOEI5RUJDOTQ1NTY5QTk3ODkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6ODlDNjU2NDZGMzhCMTFFOEI5RUJDOTQ1NTY5QTk3ODkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz43HaHBAAAE+ElEQVR42uRaa2gUVxi92YzRoEkltVaNqFVrbBOkVdv6wEdFDVSF/kl/tNUWlL6UKiiohRYrhSgIlv4QlAhBVFrqIxAN9QUKBQWtFZ+pj6qtbZPUuIkx8RFjej72THNzndmdmR3Nwh44md25j7nz3e91v01GVVXVc0qpT8EP1OO4AZ4Fr4Nvg93B3mxrB38CfwWXgo1gA/vOUP5xH2xxuF/LdYwB28AeYCvb/gRHgw+1/o/Am6C8Vwb4G1igtcvYP8AvwdlgNviFhT9fUxBOGApOjrP4hapr0M6XHOPSPtx4BxPN4BFubFSEG+FO67itUhOiMZ+Dp8G9HvpH47SNphBsDRkrGnFP67ANPAFOAC1D5WzkgA+4MDdcAAs5hzwoizuYTdUVNrFvN/aLUNWHsT1izHkF/AusA0+CW8EFbMuglpgm9XycNY4EB4J9ZQ0WfcALbMwEy8BvXSb3izDmMLFL+/xDEvNsAedyUzdFDB8g3+9odhiGLacqMnkVbf3EVL+HKn1wnL5G3rkmotIXIxlWRTP6WQ42nS7I0cLsDYtJ0DPgIfBMiA9aBH5Iz37K4xhJ1sb6fM5l8FqA9bVqn/uLIO7yS09mhUGwnOFth3YvnwlPL+2exO4l4Hmw0mGeIvCAz2evBNcEWPO/uuO0mI4KRoDjwe0BJl1Dx7MjQb8e7LvdRRA2pL0iwVyDwHVJaOwA/YvFJOYcd/BqitivqPvBBH1eDil8/p83ZPLg1BInd3/a+Aq8lYA/J/mMU6ZGFNNZphLkVHvYY98jAeYXvzXKFISYwyvaqSwo3jAcnR2a1jMy2c/zAjlT/OLjpfpovs4L7vBI30kQQ7TvPQMKIUoT000rm9cCI2ONehD4fNIrZns8kZpuoZMgwkii8hzulYIrwLd82LN9NP4uQVSxMRFcFYYtWiHMUcpcZLXH/vl0huIHdjskVIqCqwbfc5ljPx183yTW3Rq2IN5VsTLdah/a8xE9vymI/rzW0WQl56hRHSU8i/nDbQoiGXRztZMUwKssyuihbQGLNcJJLuMaU8E0woL4qplMv/UX66c66o4DjDGhhX1bEFL2krLW910oiGkqVjorN+6XxRljR6amAM+TypyUFF/SBfG+Fr8rA0xawEOXUySRcppeF81yCWXfqFhFq1xbqNvPAtW82iXG+oBnDVuA7aZpZAXczTb1eNU4mmAXzXODVJZ/1ATa4HLe2Ac+y7XKaVV+o/g7wJpP0mGXOxVmgmAvvfoyj/3tU+MZQ00lKbroYbwI6zUKdA+4iQ7WL27SIqaD40xBBKlZfuazv+zgOw73vdYhyhL4Da+op/keBWstI4SmUhR50pANLKEp1okQNjNB2UAvmi5opp+RqFEYoa2tosM7lkaC0EuIu8UUXgTnqVgNr1gPKfTc0idHG9RC4VWzunWXUv2HR/Gr9OrNzE0yOMY2wbWMBsPpYEew7bhWDlD06HlPUBBF2udZ8pInmL4O9jmR1BlqjRAnJjaBLy+fcx3Gvc7zyQWGsKnMQ6Z0oXY0RJhADdRuXjLqBY9cwtObKvYTQInqqIRLaNvJ02EuU2XzHJDLsCf/t7BRdf7fBVvjKqhtTwunLeb225ilVVIQH1OtxTSWs6xVyJw/nztuL1SyxnO810YHtJjOV06RD1g3cEILhazbax0FLL+2/w7OUR2F1u4hC6CJm1L6nwADAHyYG4EKjeMaAAAAAElFTkSuQmCC)
    no-repeat;
  background-position: right center;
  background-size: 33px auto;
}
.history-price .price {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  right: 13px;
  height: auto;
  line-height: 1.5em;
  font-size: 18px;
  color: #e53329;
}
.history-price.beout .price {
  color: #999;
}
.page-bd {
  margin-top: 20px;
  .h4 {
    color: 666;
    margin: 0;
    padding-left: 10px;
    border-left: 3px solid #cfa972;
    position: relative;
  }
}
.desc_box dl {
  display: flex;
  line-height: 20px;
  color: #666;
  dt {
    width: 100px;
    text-align: justify;
    &::after {
      content: "";
      display: inline-block;
      width: 100%;
    }
  }
}

.a-content-main .artinfo {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  position: relative;
  padding-left: 20px;
  padding-right: 100px;
}
.a-content-main .headimgbox {
  float: left;
  border: 5px solid #ebebeb;
  width: 80px;
  height: 80px;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}

.a-content-main .artinfo .name {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}

.a-content-main .artinfo .des {
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  color: #999;
  display: flex;
  align-items: center;
  button {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
  }
}
.content-s {
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  box-sizing: content-box;
}
.a-content-main .artinfo .des-l > span:last-child {
  margin-left: 20px;
}
.box-card {
  margin-top: 20px;
}

.price_content {
  background: #fff;
  border-radius: 4px;
  margin-left: 0;
  margin-right: 0;
}
.intro {
  display: flex;
  justify-content: flex-start;
}
.intro .avatar {
  width: 60px;
  height: 60px;
  border-radius: 5px;
}

.intro .text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  padding-left: 10px;
  text-align: left;
  font-size: 15px;
  width: calc(100% - 60px);
  position: relative;
}

.intro .text .title {
  font-size: 15px;
  color: #333333;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  line-height: 1.2;
}

.intro .text .price {
  color: #e53329;
}

.intro .text .extra {
  line-height: 17px;
  padding-right: 0;
  margin-top: 6px;
  /* position: absolute; */
  margin-left: -3.5em;
}

.intro .text .extra img {
  width: 17px;
  vertical-align: middle;
  margin-right: 5px;
}

.intro .text .extra span {
  vertical-align: bottom;
  margin: 0 8px 0 1px;
  color: rgba(0, 0, 0, 0.55);
}

.intro .text .extra span:nth-child(6) {
  margin-right: 0;
}

.operation-con {
  text-align: center;
  height: 35px;
  margin-top: 15px;
}
.operation {
  display: inline-block;
  text-align: center;
}

.operation > div,
.operation img {
  float: left;
  height: 35px;
  line-height: 35px;
  vertical-align: top;
}

.operation .num {
  width: 188px;
  font-size: 15px;
  box-sizing: border-box;
  input {
    box-sizing: border-box;
    height: 35px;
    line-height: 35px;
    outline: 0;
    padding: 0 10px;
    border: none;
    width: 100%;
    background: #f6f6f6;
    border-top: 1px solid #bfbfbf;
    border-bottom: 1px solid #bfbfbf;
    outline: none;
    text-align: center;
    font-size: 18px;
    line-height: 100%;
  }
}
.button-con {
  height: 36px;
  text-align: center;
  margin-top: 15px;
  padding: 0 24px;
}

.button-con .button {
  display: inline-block;
  width: 100%;
  vertical-align: top;
  font-size: 16px;
  border-radius: 19px;
}

.buttons {
  margin-top: 10px;
}
.button.red {
  background: #e53329;
}
.button {
  outline: 0;
  border: none;
  color: #fff;
  border-radius: 2px;
  text-align: center;
  font-size: 14px;
  min-width: 64px;
  height: 36px;
  line-height: 36px;
  padding: 0 16px;
}
.button.weui-btn_disabled {
  color: rgba(0, 0, 0, 0.4);
  background-color: #fafafa;
}
.buttons div {
  background: #e6e8ec;
  text-align: center;
  float: left;
  width: calc((100% - 30px) / 3);
  margin: 5px;
  border-radius: 5px;
  font-size: 18px;
  color: #55585c;
  height: 50px;
  line-height: 50px;
  overflow: hidden;
}
.buttons .clear {
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: 90px 47px;
  background-position: center;
}

.buttons div img {
  width: 100%;
  vertical-align: middle;
}
</style>
<script>
import {
  AuctionAPI
} from "../../model/auction.js";
let auctionAPI = new AuctionAPI();
import Utils from '../../utils/utils'
import QrDetail from '../../components/qrdetail.vue'
export default {
  data() {
    return {
      id: this.$route.query.id,
      productId: '',
      data: {},
      info: {},
      detail: {},
      artist: {},
      synopsis: "",
      remark: "",
      lineNumber: 4,//详情显示的行数
      artistDefault: require('../../assets/image/morentx.jpg'),
      saleType: '',
      dateDiff: 0,
      is_belong: {},
      time: 0,
      timer: 0,
      ptimer: 0,
      nowtime: '',
      swiperSlides: [],
      swiperSlidesPro: [],
      bidding: [],
      allBidding: [],
      bidding_count: 0,
      favour: false,
      likeArt: false,
      oldid: '',
      max: 999999,
      //最小值
      min: 0,
      //初始值
      value: 0,
      startPrice: 0,
      maxPrice: 0,
      price: this.value,
      stepPrice: 100,
      keyboard: false,
      modelMask: false,
      btnState: false,
      addpriceState: true,
      showIswork: false,
      videoType: 2,//1：艺术家 2：作品
    }
  },
  computed: {
    addpriceStateTxt: function () {
      if (this.addpriceState) {
        return '出价'
      } else {
        return '正在出价中'
      }
    },
    likeArtTxt: function () {
      let _this = this;
      let likeArtTxt = '';
      _this.likeArt ? likeArtTxt = '已关注' : likeArtTxt = '关注'
      return likeArtTxt
    },
    favourTxt: function () {
      let _this = this;
      let favourTxt = '';
      _this.favour ? favourTxt = '已收藏' : favourTxt = '收藏'
      return favourTxt
    },
    isworkText: function () {
      let _this = this;
      let isworkText = '';
      _this.iswork ? isworkText = 'o(╥﹏╥)o' : isworkText = '(๑•̀ㅂ•́)و✧'
      return isworkText
    },
    btnStatus: function () {
      let _this = this;
      if (!_this.btnState) {
        if (_this.is_belong.orderno) {
          if (_this.is_belong.deal_state == 1) {
            return '已支付'
          } else if (_this.is_belong.deal_state == 2) {
            return '已退款'
          } else {
            return "去支付"
          }
        } else {
          if (_this.StatusCode == 4010) {
            return '已结拍'
          } else if (_this.StatusCode == 4016) {
            return '已下架'
          } else if (_this.StatusCode == 4011) {
            return '未上拍'
          } else {
            return '已结束'
          }
        }
      } else {
        if (_this.is_belong.orderno) {
          if (_this.is_belong.deal_state == 0) {
            return '去支付'
          }
          return ""
        } else {
          return '出价'
        }
      }
    },
  },
  filters: {
    formatTimer(time) {
      function normalize(x) {
        return x < 10 ? '0' + x : x;
      }
      if (time > 0) {
        var h = normalize(time / 3600 | 0);
        var m = normalize(time / 60 % 60 | 0);
        var s = normalize(time % 60);

        return '距结束' + (h + ':' + m + ':' + s);

      } else {
        return '已结束';
      }
    },
    numberFormat(number, decimals, dec_point, thousands_sep, roundtag) {
      /*
       * 参数说明：
       * number：要格式化的数字
       * decimals：保留几位小数
       * dec_point：小数点符号
       * thousands_sep：千分位符号
       * roundtag:舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入
       * */
      number = (number + '').replace(/[^0-9+-Ee.]/g, '');
      roundtag = roundtag || "ceil"; //"ceil","floor","round"
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {

          var k = Math.pow(10, prec);
          console.log();

          return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k;
        };
      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
      var re = /(-?\d+)(\d{3})/;
      while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
      }

      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      }
      return s.join(dec);
    }
  },
  methods: {
    //获取作品详情
    getEPDetails() {
      let _this = this;
      let moment = require("moment");
      auctionAPI.getEPDetails(
        {
          ProductId: _this.id,
          UserId: _this.user ? _this.user.id : "",
          Type: _this.videoType
        }
      ).then((res) => {
        //设置作品状态
        if (res.StatusCode == 200) {
          _this.StatusCode = 200;
        } else if (res.StatusCode == 4010) {
          _this.StatusCode = 4010
        } else if (res.StatusCode == 4016) {
          _this.StatusCode = 4016
        }
        if (res.data) {
          if (res.data.is_belong) {
            _this.is_belong = res.data.is_belong;
          }
          _this.info = res.data;
          _this.productId = res.data.product_id;
          _this.nowtime = res.data.nowtime;
          _this.dateDiff = moment(_this.nowtime).diff(moment(), 'millisecond')
          _this.favour = res.data.myfav;
          _this.likeArt = (res.data.artistInfo.is_like ? true : false);
          _this.oldid = res.data.old_id;
          _this.stepPrice = res.data.increase_price || 0;
          _this.startPrice = res.data.start_price || 0;
          _this.setDetail(_this.info);
          if (res.data.image) {
            _this.swiperSlides = res.data.image;
            _this.swiperSlidesPro = res.data.product_imgs;
          }
        }
      }).catch((res) => {
        if (res.StatusCode == 4011) {
          _this.StatusCode = 4011
        }
        setTimeout(function () {
          _this.$router.go(-1);//返回上一层
        }, 1500)
      })
    },
    setDetail(data) {
      let _this = this;
      _this.setProductDec(data);
      _this.setHistoryPrice(data.bidding);
      _this.setProductCountDown(data.end_date);
      _this.intervalGetBiddingHistory();
    },
    //设置作品简介
    setProductDec(data) {
      let tips = '暂无介绍';
      let _this = this;
      let detail = {};
      let artist = {};
      detail.suffix1 = data.suffix1;
      detail.remark = data.remark || tips;
      detail.index = 1;
      detail.showTotal = true;
      // 显示展开还是收起
      detail.exchangeButton = true;
      // 是否显示展开收起按钮
      detail.showExchangeButton = false;
      detail.look_count = data.look_count || 0;
      detail.quality = data.quality;
      detail.create_year = data.create_year;
      detail.standard_width = data.standard_width;
      detail.standard_height = data.standard_height;
      detail.standard_length = data.standard_length;
      detail.standard = data.standard;
      //是专场
      if (data.special_id) {
        detail.special_id = data.special_id;
        detail.special_name = data.special_name;
      }
      artist.artist_photo = data.artistInfo.artist_photo;
      artist.artist_name = data.artistInfo.artist_name || '';
      artist.artist_id = data.artistInfo.artist_newid || '';
      artist.product_count = data.artistInfo.product_count || 0;
      artist.look_count = data.artistInfo.user_like_count || 0;
      artist.synopsis = data.artistInfo.synopsis || tips;
      artist.index = 2;
      artist.showTotal = true;
      // 显示展开还是收起
      artist.exchangeButton = true;
      // 是否显示展开收起按钮
      artist.showExchangeButton = false;
      _this.detail = detail;
      _this.artist = artist;
      _this.synopsis = _this.artist.synopsis.replace(/\n/gm, "<br/>")
      _this.remark = _this.detail.remark.replace(/\n/gm, "<br/>")
    },
    setHistoryPrice(bidding) {
      if (bidding && bidding.length > 0) {
        this.bidding_count = bidding.length;
        this.bidding = bidding;

        this.setmaxPrice(this.bidding)
      }
    },
    //设置最高出价
    setmaxPrice(arrs) {
      if (arrs.length > 0) {
        let max = arrs[0]
        arrs.forEach(element => {
          if (element > max) {
            max = element
          }
        });
        this.maxPrice = max.price;
      } else {
        if (this.startPrice >= 0 && arrs.length == 0) {
          this.maxPrice = this.startPrice
        }
      }
    },
    //设置倒计时
    setProductCountDown(enddate) {
      let _this = this;
      let moment = require("moment");
      let nowtime = moment();
      let overTime = moment(enddate, 'YYYY/MM/DD HH:mm:ss');
      let fromTime = overTime.diff(nowtime, 'millisecond');
      let fromTime1 = fromTime - _this.dateDiff;
      _this.time = Math.floor(fromTime1 / 1000);
      _this.getBtnStatus();
      _this.timer && clearInterval(_this.timer);
      _this.timer = setInterval(function () {
        let time = _this.time;
        if (time > 0) {
          time--
        } else {
          time = 0;
        }
        _this.time = time;
        _this.getBtnStatus();
      }, 1000);
    },
    //获取当前按钮状态
    getBtnStatus() {
      let _this = this;
      if (_this.time > 0) {
        _this.btnState = true;
      } else {
        if (_this.is_belong.orderno) {
          if (_this.is_belong.deal_state === 0) {
            _this.btnState = true;
          } else if (_this.is_belong.deal_state === 1) {
            _this.btnState = false;
          } else if (_this.is_belong.deal_state === 2) {
            _this.btnState = false;
          }
        } else {
          _this.btnState = false;
        }
        clearInterval(_this.timer)
        clearInterval(_this.ptimer);
      }
    },
    intervalGetBiddingHistory() {
      let _this = this;
      if (_this.time > 0) {
        _this.ptimer = setInterval(_this.getBiddingHistory, 60000)
      }
    },
    getBiddingHistory() {//定时获取出价历史
      let _this = this;
      auctionAPI.biddingHistory({
        ProductId: _this.productId
      }).then((res) => {
        _this.setHistoryPrice(res.bidding)
        _this.setProductCountDown(res.end_date)//设置结拍时间倒计时
      })
    },
    showKeyboard() {
      this.keyboard = !this.keyboard;
    },
    beforeAddprice() {
      let _this = this;
      if (!_this.btnState) {
        return
      }
      _this.checkUserLogin().then(() => {
        _this.checkIsOrderOrAuction()
      })
    },
    checkIsOrderOrAuction() {
      let _this = this;
      if (_this.is_belong.orderno) {
        _this.$router.push({ path: '/checkout', query: { 'orderIds': _this.is_belong.order_newid, 'orderNos': _this.is_belong.orderno } })
        //window.location.href = _this.GLOBAL.PROTOCOL + location.host + '/payment/orderpay?orderno=' + _this.is_belong.orderno;
      } else {
        _this.addpriceState = true;
        _this.showKeyboard();
        _this.price = _this.maxPrice + _this.stepPrice//在此设置输入框的价格，防止输入框定时跟着价格刷新
      }
    },
    addprice() {
      //出价接口
      let _this = this;
      if (_this.time > 0 && _this.addpriceState) {
        if (_this.price <= 0) {
          _this.$message({
            message: '出价不能为0元哦',
            type: 'error'
          });
          return
        }
        if (_this.price <= _this.maxPrice) {
          _this.$message({
            message: '出价不能低于当前最高价格',
            type: 'error'
          });
          return
        }
        _this.addpriceState = false;
        auctionAPI.addPrice2({
          customerid: Utils.Encrypt(_this.user ? _this.user.id : ""),
          price: Utils.Encrypt(_this.price),
          nickname: Utils.Encrypt(_this.user.nickname),
          headimgurl: _this.user.headimg,
          productid: Utils.Encrypt(_this.productId)
        }).then((res) => {
          _this.addpriceState = true;
          if (res.success) {
            _this.showKeyboard();
            _this.$message({
              message: '出价成功',
              type: 'success'
            });
            _this.setHistoryPrice(res.data.data);
            _this.setProductCountDown(res.data.enddate)//设置结拍时间倒计时
          } else {
            if (res.StatusCode == 201) {
              _this.$confirm('您的保证金不足。拍品出价需缴纳100元保证金，保证金随时可退!', '缴纳保证金提示', {
                confirmButtonText: '缴纳',
                cancelButtonText: '我知道了',
                type: 'warning'
              }).then(() => {
                _this.$router.replace({ path: '/usercenter/deposit', query: { 'return_url': encodeURIComponent(window.location.href) } })
              }).catch(() => { });
            } else if (res.StatusCode == 202) {
              _this.$alert('您好，由于您上次拍得的作品未在7天内支付,如需出价,请联系客服。客服电话:400-088-8769', '订单7天未支付提示', {
                confirmButtonText: '我知道了',
                type: 'warning'
              }).then(() => {
                _this.$router.replace({ path: '/usercenter/deposit', query: { 'return_url': encodeURIComponent(window.location.href) } })
              })
            } else {
              _this.$alert('请尝试刷新页面', '出错了', {
                confirmButtonText: '我知道了',
                type: 'warning'
              }).then(() => {
                window.location.reload()
              })
            }
          }
        }, (res) => {
          _this.addpriceState = true;
          _this.$alert(res.errorMessage, '出错了', {
            confirmButtonText: '我知道了',
            type: 'warning'
          }).then(() => {
          })
        })
      }
    },
    //关注艺术家
    handleAddArtlike(id) {
      let _this = this;
      _this.addLike(id).then(() => {
        if (!_this.likeArt) {
          _this.likeArt = true
        } else {
          _this.likeArt = false
        }
        _this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
    },
    //处理按键
    _handleKeyPress(e) {
      let num = e.target.dataset.num;
      //不同按键处理逻辑
      // -1 代表无效按键，直接返回
      if (!num) return false;
      switch (String(num)) {
        //删除键
        case 'D':
          this._handleDeleteKey();
          break;
        default:
          this._handleNumberKey(num);
          break;
      }
    },
    //处理删除键
    _handleDeleteKey() {
      //先把价格转成string 方便处理，我这边错了，现在一个是获取它的当前，还有一个，还有个啥我看看
      let S = String(this.price);
      //如果没有输入，直接返回
      if (!S.length) return false;
      //否则删除最后一个
      if (S.substring(0, S.length - 1) === '') {
        this.price = 0;
        return
      }
      this.price = parseInt(S.substring(0, S.length - 1), 10);
    },
    //处理数字
    _handleNumberKey(num) {
      let S = String(this.price);
      //如果有小数点且小数点位数不小于2
      if (S.indexOf('.') > -1 && S.substring(S.indexOf('.') + 1).length < 2) {
        this.price = S + num;
      }
      //没有小数点
      if (!(S.indexOf('.') > -1)) {
        //如果当前数字为0
        if (this.price == 0) {
          if (num == '0' || num == '00') {
            //this.price = 0;
            this.update(0)
          } else {
            //this.price = parseInt(num, 10)
            this.update(parseInt(num, 10))
          }
        }
        else {
          //if (S.length && Number(S.charAt(0)) === 0) return;
          this.update(parseInt(S + num, 10))
        }

      }

    },
    update: function (val) {
      let _this = this;
      //让输入的值在限定范围内
      if (val > this.max) {
        val = this.max;
        _this.$message({
          message: '哎呀，只能到这个价格了哦~',
          type: 'error'
        });
      }
      if (val < this.min) {
        val = this.min
        _this.$message({
          message: '哎呀，只能到这个价格了哦~',
          type: 'error'
        });
      }
      this.price = val;
    },
    add: function () {
      if (this.price >= this.max) {
        return
      }
      this.price = this.price + this.stepPrice;
    },
    subtract: function () {
      if (this.price - this.stepPrice <= this.min) {
        this.price = this.min;
        return
      }
      if (this.price - this.stepPrice <= this.maxPrice) {//起拍价不是0
        this.price = this.maxPrice + this.stepPrice;
        return
      }
      this.price = this.price - this.stepPrice;
    },
  },
  components: {
    QrDetail
  },
  created() {
    this.getEPDetails()
  },
  destroyed() {
    clearInterval(this.timer)
    clearInterval(this.ptimer)
  },
}
</script>